import { render, staticRenderFns } from "./addNotepadDetail.vue?vue&type=template&id=76f59222"
import script from "./addNotepadDetail.vue?vue&type=script&lang=js"
export * from "./addNotepadDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports